import React from "react";
import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import styles from "./enhancedCheckboxPlaceholder.css";
import classNames from "classnames";
import { VerticalSeparator } from "../separators/verticalSeparator/verticalSeparator";
import { L10nId, L10nHtml, L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";

interface Props extends React.PropsWithChildren<{}> {
  value: boolean;
  id: string;
  checkboxLabelId: L10nId;
  descriptionLabelId: L10nId;
  titleLabelId: L10nId;
  onCheckboxChange: (value: boolean) => void;
  innerFormSubmit: () => void;
  innerFormDiscard: () => void;
  isEditing?: boolean;
}

export const EnhancedCheckboxPlaceholder = ({
  value,
  id,
  checkboxLabelId,
  onCheckboxChange,
  children,
  descriptionLabelId,
  titleLabelId,
  isEditing,
  innerFormSubmit,
  innerFormDiscard
}: Props) => {
  return (
    <div className={classNames(styles.container, { [styles.editing]: isEditing })}>
      <div style={{ alignSelf: "stretch", display: "flex", alignItems: "center" }}>
        <div style={{ marginRight: "16px" }}>
          <p className={styles.title}>
            <L10nHtml id={titleLabelId} />
          </p>
          <p className={styles.description}>
            <L10nHtml id={descriptionLabelId} />
          </p>
        </div>
        <VerticalSeparator />
      </div>
      {children}

      {isEditing && (
        <div className={classNames(styles["form-actions"])}>
          <div className={classNames(styles.discard, styles["discard-transitions"])}>
            <button className={styles["discard-button"]} type={"button"} onClick={innerFormDiscard}>
              <i className="icon-close-cross" />
              <L10n id={"settings.discard"} />
            </button>
          </div>
          <div style={{ alignSelf: "stretch" }}>
            <VerticalSeparator />
          </div>
          <div className={styles.apply}>
            <AgentButton onClick={innerFormSubmit}>
              <L10n id={"conversation.input.save"} />
            </AgentButton>
          </div>
        </div>
      )}

      {!isEditing && (
        <div style={{ alignSelf: "stretch", display: "flex", alignItems: "center" }}>
          <VerticalSeparator />
          <div
            style={{ marginLeft: "24px", minWidth: "68px", display: "flex", alignItems: "center" }}
          >
            <CheckboxInput
              value={value}
              id={id}
              label={intl.formatMessage(checkboxLabelId)}
              onChange={onCheckboxChange}
              smallStyle
              displayNoColors
              noMarginBottom
            />
          </div>
        </div>
      )}
    </div>
  );
};
